import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SearchDropdownComp from 'components/SearchDropdown/SearchDropdown';
import AddParticipantSearchBar from 'components/AddParticipantDrawer/Search/AddParticipantSearchBar';
import AddParticipantSearchResults from 'components/AddParticipantDrawer/Search/AddParticipantSearchResults';
import classes from './AddParticipantSearch.module.scss';

class AddParticipantSearch extends React.PureComponent {
  render() {
    const { handleSetIsFocused, isFocused, maxItems } = this.props;

    return (
      <div className={classes.addParticipantSearch}>
        <SearchDropdownComp
          buttonComponent={
            <AddParticipantSearchBar
              {...this.props}
            />
          }
          menuComponent={
            <AddParticipantSearchResults
              {...this.props}
            />
          }
          isVisible={isFocused}
          clickOutsideHandler={handleSetIsFocused}
          maxItems={maxItems}
          itemHeight={42}
        />
      </div>
    );
  }
}

AddParticipantSearch.propTypes = {
  handleSetIsFocused: PT.func.isRequired,
  isFocused: PT.bool,
  maxItems: PT.number
};

export default AddParticipantSearch;
